import React, { useEffect, useState } from "react";
import { Grid, Typography, TextField, InputAdornment, IconButton, Button } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import ControlPointIcon from "@mui/icons-material/ControlPoint";

const HeaderSection = ({ handleAddUserOpen, partnerName, searchQuery, setSearchQuery, handleSearch, fetchData }) => {
  const [userType, setUserType] = useState("");

  useEffect(() => {
    const storedUserType = sessionStorage.getItem("uType");
    setUserType(storedUserType);
  }, []);

  const isAdmin = userType !== "RETAILER"; // Check if user is admin

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  const handleChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleClearSearch = () => {
    setSearchQuery("");
    fetchData(0); // Fetch data without search query
  };

  return (
    <Grid container alignItems="center" justifyContent="space-between">
      <Grid item>
        <Typography sx={{ fontWeight: "bold", fontSize: "22px" }}>{partnerName}</Typography>
      </Grid>

      <Grid item style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        {/* Search Field */}
        <TextField
          label="Search"
          variant="outlined"
          value={searchQuery}
          onChange={handleChange}
          onKeyPress={handleKeyPress}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {searchQuery && (
                  <IconButton onClick={handleClearSearch} size="small">
                    <ClearIcon />
                  </IconButton>
                )}
                <IconButton onClick={handleSearch}>
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
          sx={{ minWidth: "250px" }}
        />

        {/* Add User Button - Visible only for Admins */}
        {isAdmin && (
          <Button
            variant="contained"
            onClick={handleAddUserOpen}
            startIcon={<ControlPointIcon />}
            sx={{
              backgroundColor: "green",
              color: "white",
              borderRadius: "8px",
              fontWeight: "bold",
              textTransform: "none",
              padding: "1rem",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              "&:hover": { backgroundColor: "darkgreen" },
            }}
          >
            Add User
          </Button>
        )}
      </Grid>
    </Grid>
  );
};

export default HeaderSection;
